module.exports = __webpack_public_path__ + "b5ec6efb5bd32e9e99b00125f103409a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/catherine-meade.jpg
// module id = 508
// module chunks = 0